<footer [class.unauthenticated]="(isAuthenticated$ | async) === false">
  &copy; {{ currentYear }}. Todos os Direitos Reservados - Versão:
  {{ appVersion }}
</footer>
